import React, { FC } from 'react'
import { NextSeo } from 'next-seo'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'
import { brandingUrl } from 'config/constants'

type Props = {
  title: string
  description?: string
  keywords?: string
  ogImage?: string
}

const SiteSEO: FC<Props> = ({ title, description, keywords, ogImage }) => {
  const { t } = useTranslation('common')
  const { asPath } = useRouter()

  const path = asPath.split('?')[0].split('#')[0]
  const canonical = `${brandingUrl}${path === '/' ? '' : path}`
  const desc = description ?? t('howxm.description')
  const image = `${brandingUrl}${ogImage ?? '/logo.png'}`

  return (
    <NextSeo
      title={title}
      description={desc}
      canonical={canonical}
      additionalMetaTags={[{ name: 'keywords', content: keywords ?? t('howxm.keywords') }]}
      openGraph={{
        type: 'website',
        siteName: t('howxm.title'),
        title,
        description: desc,
        url: canonical,
        locale: 'zh_CN',
        images: [{ url: image, width: 301, height: 301, alt: title }],
      }}
      twitter={{ cardType: 'summary_large_image' }}
    />
  )
}

export default SiteSEO
